export function getDomainName() {
    const dotIndex = window.location.hostname.indexOf('.');
    return window.location.hostname.substring(dotIndex + 1);
}

export function getUrlParameter(parameterName) {
    const queryString = window.location.search.split('?')[1];
    const params = new URLSearchParams(queryString);
    return params.get(parameterName);
}
